import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBug = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 250,
	height: 251,
	viewBox: "0 0 250 251",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "ð¦ icon \"Bug\"",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M249.994 141.548C249.761 150.058 242.564 156.733 234.05 156.733H207.031V164.546C207.031 175.221 204.647 185.339 200.39 194.402L229.799 223.81C235.9 229.912 235.9 239.805 229.799 245.907C223.696 252.009 213.803 252.009 207.701 245.907L180.974 219.18C168.889 228.982 153.491 234.858 136.719 234.858V115.718C136.719 112.482 134.095 109.858 130.859 109.858H119.14C115.905 109.858 113.281 112.482 113.281 115.718V234.858C96.508 234.858 81.1101 228.982 69.0251 219.18L42.2986 245.907C36.196 252.009 26.3029 252.009 20.2009 245.907C14.0993 239.805 14.0993 229.912 20.2009 223.81L49.6091 194.402C45.3523 185.339 42.9685 175.221 42.9685 164.546V156.733H15.9499C7.43623 156.733 0.239451 150.058 0.00605272 141.548C-0.236623 132.718 6.84932 125.483 15.6247 125.483H42.9685V96.7991L20.2009 74.0315C14.0993 67.9295 14.0993 58.0364 20.2009 51.9343C26.3034 45.8323 36.196 45.8323 42.2986 51.9343L68.9719 78.6082H181.027L207.7 51.9348C213.803 45.8328 223.696 45.8328 229.798 51.9348C235.9 58.0369 235.9 67.93 229.798 74.032L207.031 96.7991V125.483H234.375C243.15 125.483 250.236 132.718 249.994 141.548ZM125.488 0.483154C95.2849 0.483154 70.8005 24.9675 70.8005 55.1707H180.176C180.176 24.9675 155.691 0.483154 125.488 0.483154Z",
			fill: "#BEBEBE"
		})
	})
});
export default SvgBug;
